import React, { useState } from 'react';
import '../styles/AdminLoginModal.css';

const AdminLoginModal = ({ currentLang, onLogin, onClose }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (onLogin(username, password)) {
            setUsername('');
            setPassword('');
        } else {
            setError(currentLang === 'ar' ? 'اسم المستخدم أو كلمة المرور غير صحيحة' : 'Invalid username or password');
        }
    };

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <span className="close" onClick={onClose}>&times;</span>
                <h2 className="modal-title">
                    {currentLang === 'ar' ? 'تسجيل دخول المدير' : 'Manager Login'}
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>{currentLang === 'ar' ? 'اسم المستخدم' : 'Username'}</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>{currentLang === 'ar' ? 'كلمة المرور' : 'Password'}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <div className="error-message">{error}</div>}
                    <button type="submit" className="submit-btn">
                        {currentLang === 'ar' ? 'تسجيل الدخول' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLoginModal;

